import PopularMovies from './components/movies/PopularMovies.vue';
import MovieDetail from './components/movies/MovieDetail.vue';
import PopularSeries from './components/series/PopularSeries.vue';
import SerieDetail from './components/series/SerieDetail.vue';
import PopularPeople from './components/people/PopularPeople';
import PersonDetail from './components/people/PersonDetail.vue';

export const routes = [
  {
    path: '/',
    redirect: '/movies',
  },
  {
    name: 'movies',
    path: '/movies',
    component: PopularMovies,
    children: [
      {
        name: 'detailM',
        path: ':id',
        component: MovieDetail,
      }
    ],
  },
  {
    name: 'series',
    path: '/series',
    component: PopularSeries,
    children: [
      {
        name: 'detailS',
        path: ':id',
        component: SerieDetail,
      }
    ],
  },
  {
    name: 'people',
    path: '/people',
    component: PopularPeople,
    children: [
      {
        name: 'detailP',
        path: ':id',
        component: PersonDetail,
      },
    ],
  },
];
